import Card from "../Card";
import SecondaryButton from "../SecondaryButton";

export default function ExploreSpheron({
  isEligible,
}: {
  isEligible: boolean;
}) {
  return (
    <Card
      className={
        "!py-6 flex-col gap-4 " +
        (isEligible ? "w-full" : "w-[512px] !bg-[#141416] ")
      }
    >
      {!isEligible && (
        <>
          <h3 className="text-white text-2xl uppercase tracking-wider">Don't worry</h3>
          <p className="text-base text-[#9D9D9D] -mt-2">
            You can still be part of the decentralized compute revolution.
          </p>
        </>
      )}
      {isEligible && (
        <>
          <h3 className="text-white text-2xl uppercase tracking-wider">
            Looking for enterprise-grade GPUs?
          </h3>
          <p className="text-base text-[#9D9D9D] -mt-2 text-center">
            Spheron’s next chapter is live. Get on-demand, enterprise-grade GPU
            compute built to scale, now at app.spheron.ai.
          </p>
        </>
      )}
      <SecondaryButton
        variant={"light"}
        onClick={() => window.open("https://app.spheron.ai", "_blank")}
      >
        Explore Enterprise GPUs
      </SecondaryButton>
    </Card>
  );
}
